import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import MoneyMindDashboard from './MoneyMindDashboard';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { fetchCompanyMoneyMindDashboard } from './companyMoneyMindApi';

/** Company MoneyMind → Dashboard, scoped to this company. */
const CMoneyMindDashboard = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();

  const fetcher = useCallback(
    () => fetchCompanyMoneyMindDashboard(department),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>MoneyMind | Shoorah</title>
      </Helmet>
      <MoneyMindDashboard
        fetcher={fetcher}
        populationLabel={isB2BFansMode ? 'members' : 'employees'}
      />
    </div>
  );
};

export default CMoneyMindDashboard;
